export const selectFileManager = (state) => state.files;
